import 'regenerator-runtime/runtime';
import { createhttp } from 'lib/services/http';

import { ChimeSchema } from './schemas';

const http = createhttp({ baseURL: '/api/platform-admin/v1/' });

const validateHandler = (schema, object, apiCall) => {
  return schema.validate(object).then(() => {
    return apiCall();
  });
};

export const createAmazonId = (data) => {
  const path = `/chime`;
  const apiCall = () => {
    return http.post(path, data);
  };

  return validateHandler(ChimeSchema.Create, data, apiCall);
};

export const updateAmazonId = (loginId: string, data) => {
  const path = `/chime/${loginId}`;
  const apiCall = () => {
    return http.put(path, data);
  };

  return validateHandler(ChimeSchema.Update, data, apiCall);
};

export const deleteAmazonId = (loginId: string) => {
  const path = `/chime/${loginId}/delete`;
  const apiCall = () => {
    return http.delete(path);
  };

  return validateHandler(ChimeSchema.NONE, {}, apiCall);
};

export const getAmazonId = (loginId: string) => {
  const path = `/chime/${loginId}/retrieve`;
  const apiCall = () => {
    return http.get(path);
  };

  return validateHandler(ChimeSchema.NONE, {}, apiCall);
};

export default {
  getAmazonId,
  createAmazonId,
  updateAmazonId,
  deleteAmazonId,
};
